export default __webpack_public_path__ + "static/media/newIllustration.363e85d0.png";